import React, { Component } from "react";
import SEO from "react-seo-component";
import { Col, Container, Row } from "reactstrap";

class Section extends Component {
  render() {
    return (
      <React.Fragment>
        <SEO
          title={"What is QikTruck?"}
          titleTemplate={"QikTruck"}
          titleSeparator={`-`}
          description={
            "QikTruck is a platform that connects small trucking companies with shippers/movers in need of transportation services."
          }
          image={"https://media.qiktruck.co.za/qiktruck-preview-header.png"}
          pathname={"https://qiktruck.co.za/investors"}
          twitterUsername={"qiktrucksa"}
        />
        <section id="home">
          <Container>
            <Row className="justify-content-center what-is-qiktruck">
              <Col>
                <h1>
                  QikTruck: <span className="orange">Moving goods</span>
                  <span className="green">on-demand</span>
                </h1>
                <br />
                <br />
                <h2>What is QikTruck?</h2>
                <ul>
                  <li>
                    QikTruck is a platform that connects small trucking
                    companies with shippers in need of transportation services.
                    It aims to solve the problem of inefficient and
                    time-consuming truck dispatch processes for small trucking
                    companies, which often struggle to compete with larger
                    companies due to a lack of resources and access to
                    technology. By using QikTruck, small trucking companies can
                    easily find and book loads, streamline their dispatch
                    process, and increase their profitability. It also helps
                    shippers find reliable and cost-effective transportation
                    options, enabling them to optimize their supply chain and
                    reduce transportation costs. Overall, QikTruck aims to
                    create a more efficient and cost-effective transportation
                    network for both small trucking companies and shippers.
                  </li>
                  <li>
                    <h5>Rephrase ?</h5>
                    QikTruck is a platform that connects small trucking firms
                    with shippers seeking transportation services. It aims to
                    resolve the issue of inefficient and time-consuming truck
                    dispatch processes for small trucking companies, which often
                    have difficulty competing with larger firms due to a lack of
                    resources and access to technology. By using QikTruck, small
                    trucking companies can easily find and book loads,
                    streamline their dispatch process, and increase their
                    profitability. It also helps shippers find reliable and
                    cost-effective transportation options, allowing them to
                    optimize their supply chain and reduce transportation costs.
                    Overall, QikTruck's goal is to create a more efficient and
                    cost-effective transportation network for both small
                    trucking firms and shippers.
                  </li>
                  <li>
                    We are committed to empowering people to move goods through
                    our innovative on-demand delivery and truck hire services.
                  </li>
                  <li>
                    We are dedicated to providing high-quality service at a
                    reasonable price, with a focus on customer satisfaction and
                    value.
                  </li>
                </ul>
                <h2>Market</h2>
                <ul>
                  <li>
                    The market opportunity for QikTruck is significant, as the
                    trucking industry is a major contributor to the global
                    economy. According to the American Trucking Association, the
                    trucking industry in the United States alone generated
                    $796.7 billion in revenue in 2019, representing 80.9% of the
                    total spent on domestic freight transportation. In addition,
                    the global trucking industry is expected to reach a value of
                    $1.5 trillion by 2023, according to a report by Mordor
                    Intelligence. With QikTruck's focus on small trucking
                    companies, which make up a significant portion of the
                    market, there is a large potential for growth and success in
                    this industry.
                  </li>
                  <li>
                    According to the South African Revenue Service (SARS), the
                    trucking industry in South Africa generated approximately
                    R29.5 billion (around $2 billion) in revenue in 2020. The
                    South African trucking industry is also facing challenges
                    similar to those faced by small trucking companies in other
                    countries, including a lack of access to technology and
                    resources, which can make it difficult for them to compete
                    with larger firms. QikTruck would potentially tap into this
                    market and help small trucking companies in South Africa to
                    streamline their dispatch processes, increase their
                    profitability, and find reliable transportation options.
                    However, it is difficult to accurately estimate the size of
                    the market opportunity for QikTruck in South Africa without
                    more specific data on the number and size of small trucking
                    companies in the country. We are collecting the data through
                    various surveys that are helping us taylor our technology
                    solutions to each community.
                  </li>
                  <li>
                    <h5>
                      What percentage of the market share makes sense to get?
                    </h5>
                    30%. We have the resources and technology to push for the
                    level of competitiveness. A market share of 30% is realistic
                    and achievable for QikTruck given the size and competition
                    of the South African trucking industry, as well as the
                    company's resources and capabilities. This would give
                    investors confidence in QikTruck's ability to reach our
                    goals.
                  </li>
                  <li>
                    <h5>Who exactly is our best customer?</h5>
                    QikTruck is a platform that connects small trucking
                    companies with shippers in need of transportation services,
                    so both groups would potentially be considered QikTruck's
                    best customers. Small trucking companies that use QikTruck's
                    platform to find and book loads and streamline their
                    dispatch process are likely key customers for QikTruck, as
                    they provide the company with revenue through subscription
                    fees or transaction fees. Similarly, shippers that use
                    QikTruck's platform to find reliable and cost-effective
                    transportation options are also likely key customers for
                    QikTruck, as they contribute to the company's revenue
                    through transaction fees. Overall, QikTruck's best customers
                    are likely those who use the platform frequently and
                    generate significant revenue for the company through
                    subscription fees or transaction fees.
                  </li>
                  <li>
                    <h5>What is our PR Strategy?</h5>
                    1. Position QikTruck as a leading provider of transportation
                    services for small trucking companies and shippers: By
                    highlighting QikTruck's unique position in the market as a
                    platform that connects small trucking companies with
                    shippers, QikTruck can differentiate itself from other
                    transportation companies and position itself as a leader in
                    the industry.
                    <br />
                    2. Focus on the benefits of using QikTruck's platform: By
                    highlighting the benefits of using QikTruck's platform for
                    small trucking companies and shippers, such as increased
                    efficiency and cost-effectiveness, QikTruck can showcase the
                    value it brings to our customers. <br /> <br />
                    3. Build relationships with media outlets and industry
                    influencers: By building relationships with media outlets
                    and industry influencers, QikTruck can increase our
                    visibility and credibility within the transportation
                    industry. This would involve pitching story ideas, providing
                    expert commentary, or collaborating on content.
                    <br /> <br />
                    4. Utilize social media and content marketing: By using
                    social media and content marketing to share updates,
                    insights, and success stories, QikTruck can engage with our
                    audience and build brand awareness. This would involve
                    creating and sharing blog posts, infographics, videos, or
                    other types of content.
                    <br /> <br />
                    5. Foster a positive company culture: By highlighting
                    QikTruck's commitment to our employees and the community,
                    QikTruck can build a positive reputation and foster a sense
                    of trust and loyalty among our stakeholders. This would
                    involve sharing employee stories, hosting community events,
                    or promoting company initiatives.
                    <br />
                  </li>
                  <li>
                    <h5>
                      Why is this the right time for this product or service?
                    </h5>
                    <h6>Global</h6>
                    1. Growing demand for transportation services: The global
                    trucking industry is expected to reach a value of $1.5
                    trillion by 2023, according to a report by Mordor
                    Intelligence, indicating a growing demand for transportation
                    services. This would make it a good time for QikTruck's
                    platform, which connects small trucking companies with
                    shippers in need of transportation services.
                    <br /> <br />
                    2. Increasing demand for technology and efficiency: With the
                    rise of e-commerce and global supply chains, there is
                    increasing pressure on transportation companies to be more
                    efficient and cost-effective. QikTruck's platform helps
                    small trucking companies streamline their dispatch process
                    and connect with shippers in a more efficient way, which
                    would be particularly appealing in today's market.
                    <br /> <br />
                    3. Rising concerns about sustainability: As consumers and
                    businesses become more concerned about sustainability, there
                    may be an increased demand for transportation solutions that
                    are more eco-friendly and efficient. QikTruck's platform
                    would potentially help small trucking companies reduce their
                    carbon footprint and increase their efficiency, which would
                    make it an attractive solution for companies looking to
                    reduce their environmental impact.
                    <br /> <br />
                    <h6>South Africa</h6>
                    1. Challenges faced by small trucking companies: Small
                    trucking companies in South Africa may face challenges such
                    as a lack of access to technology and resources, which can
                    make it difficult for them to compete with larger firms.
                    QikTruck's platform helps small trucking companies overcome
                    these challenges and increase their profitability, which
                    would be particularly appealing in the current market.
                    <br /> <br />
                    2. Growing demand for transportation services: The trucking
                    industry in South Africa is worth approximately R29.5
                    billion (around $2 billion), indicating a growing demand for
                    transportation services in the country. This would make it a
                    good time for QikTruck's platform, which connects small
                    trucking companies with shippers in need of transportation
                    services.
                    <br /> <br />
                    3. Increasing importance of technology and efficiency: As
                    South Africa's economy grows and becomes more
                    interconnected, there may be an increased demand for
                    transportation solutions that are efficient and
                    cost-effective. QikTruck's platform helps small trucking
                    companies streamline their dispatch process and connect with
                    shippers in a more efficient way, which would be
                    particularly appealing in the current market.
                    <br /> <br />
                    4. Rising concerns about sustainability: South Africa has
                    ambitious targets for reducing our greenhouse gas emissions
                    and improving our energy efficiency, which would lead to an
                    increased demand for sustainable transportation solutions.
                    QikTruck's platform would potentially help small trucking
                    companies reduce their carbon footprint and increase their
                    efficiency, which would make it an attractive solution for
                    companies looking to reduce their environmental impact.
                    <br />
                  </li>
                  <li>
                    <h5>What is our Marketing Strategy?</h5>
                    1. Define target audience: We have defined our target
                    audience clearly in order to effectively market our
                    platform. This would include small trucking companies and
                    shippers in South Africa or a specific region or industry.{" "}
                    <br /> <br />
                    2. Identify key benefits: We have identified the key
                    benefits of our platform for both small trucking companies
                    and shippers and highlight these in our marketing efforts.
                    This would include increased efficiency, cost-effectiveness,
                    or sustainability.
                    <br /> <br />
                    3. Develop a strong brand identity: We develop a strong
                    brand identity that reflects the company's values and
                    mission. This involves creating a logo, tagline, and visual
                    style that is consistent across all marketing channels.
                    <br /> <br />
                    4. Use a variety of marketing channels: We use a variety of
                    marketing channels to reach our target audience, including
                    advertising, public relations, content marketing, social
                    media, and email marketing.
                    <br /> <br />
                    5. Measure and analyze results: We measure and analyze the
                    results of our marketing efforts in order to continually
                    improve and optimize our strategy. This would involve
                    tracking metrics such as website traffic, conversion rates,
                    and customer feedback.
                  </li>
                </ul>
                <h2>Traction:</h2>

                <ul>
                  <li>
                    <h5>How much feedback have you received so far?</h5>
                    We have received a significant amount of feedback from both
                    small trucking companies and shippers who have used our
                    platform. This feedback has been invaluable in helping us
                    understand the needs and challenges of our customers and
                    identify areas for improvement. We have received positive
                    feedback from small trucking companies who have found our
                    platform to be a helpful and efficient tool for finding and
                    booking loads, as well as from shippers who have appreciated
                    the reliability and cost-effectiveness of the transportation
                    options we offer. We have also received constructive
                    feedback on areas where we can improve, such as adding new
                    features or expanding our service to additional regions. We
                    take all feedback seriously and use it to continually
                    improve our platform and enhance the value we provide to our
                    customers.
                  </li>
                </ul>
                <ul>
                  <li>
                    <h5>What changes have you made based on that feedback?</h5>
                    We have made a number of changes to our platform based on
                    the feedback we have received from small trucking companies
                    and shippers. Some of the changes we have made include:{" "}
                    <br /> <br /> 1. Adding new features: Based on customer
                    feedback, we have added new features to our platform to make
                    it more user-friendly and efficient. This has included
                    things like a streamlined booking process, real-time load
                    tracking, and an updated mobile app.
                    <br /> <br />
                    2. Expanding our service: We have also expanded our service
                    to additional regions based on customer demand. This has
                    allowed us to better serve our customers and meet their
                    transportation needs in more areas.
                    <br /> <br />
                    3. Improving customer support: We have made a number of
                    improvements to our customer support based on customer
                    feedback, including adding more resources and support staff
                    to ensure that we are able to promptly and effectively
                    address customer inquiries and concerns.
                    <br /> <br />
                    4. Enhancing our user experience: We have made a number of
                    changes to improve the overall user experience of our
                    platform, including simplifying our interface and adding new
                    features that make it easier for small trucking companies
                    and shippers to connect and do business with each other.
                    <br /> <br />
                  </li>
                </ul>
                <ul>
                  <li>
                    <h5>How long do users stay on average?</h5>
                    Booking on the platform takes less than 30 seconds. Users
                    may take up to a minute to make a booking if they are
                    looking at various options on vehicle sizes and addons.{" "}
                    <br />
                    Time spent on the site must be the lowest possible for each
                    booking. Enabling our users to have an easy to use platform
                    that meets their basic and most advanced needs.
                  </li>
                </ul>
                <h2>Team:</h2>
                <ul>
                  <li>
                    <h5>What key roles may need to be hired for?</h5>
                    As QikTruck grows and expands, there may be a number of key
                    roles that need to be hired for in order to support the
                    company's operations and success. Some of the key roles that
                    may need to be hired for include:
                    <br /> <br />
                    Sales and business development: Hire additional sales and
                    business development professionals to help identify and
                    secure new business opportunities and partnerships.
                    <br /> <br />
                    Marketing and communications: Increases our marketing
                    efforts and expands our reach, we need to hire additional
                    marketing and communications professionals to support these
                    efforts.
                    <br /> <br />
                    Customer support: As QikTruck grows, we may need to hire
                    additional customer support staff to ensure that it is able
                    to promptly and effectively address customer inquiries and
                    concerns.
                    <br /> <br />
                    Product development: As QikTruck continues to improve and
                    expand our platform, we may need to hire additional product
                    development professionals to help design and implement new
                    features and functionality.
                    <br /> <br />
                    Operations and logistics: As QikTruck expands our
                    operations, it may need to hire additional staff to support
                    our logistics and supply chain management.
                    <br /> <br />
                    Finance and accounting: As QikTruck grows, it may need to
                    hire additional finance and accounting professionals to help
                    manage our financial operations and ensure compliance with
                    financial regulations. Text
                  </li>
                  <li>
                    <h5>What experience do we have in this industry?</h5>
                    Our team includes a diverse group of professionals with a
                    range of skills and experiences that are well-suited to the
                    transportation industry. Our team includes experts in areas
                    such as transportation logistics, technology development,
                    marketing, and customer support, all of whom have a deep
                    understanding of the needs and challenges of small trucking
                    companies and shippers. We also have a strong leadership
                    team with a track record of success in the Software and
                    transportation industry and a commitment to building a
                    strong and successful company. Overall, our team has the
                    expertise and experience necessary to effectively navigate
                    the transportation industry and drive success for QikTruck.
                  </li>
                  <li>
                    <h5>What motivates us?</h5>
                    1. Making a positive impact: We are motivated by the
                    opportunity to make a positive impact on the transportation
                    industry and help small trucking companies and shippers
                    operate more efficiently and sustainably.
                    <br /> <br />
                    2. Providing value to our customers: We are motivated by the
                    opportunity to provide value to our customers and help them
                    achieve their goals. We strive to continually improve our
                    platform and enhance the services we offer in order to
                    deliver the best possible experience for our customers.
                    <br /> <br />
                    3. Building a successful and sustainable company: We are
                    motivated by the opportunity to build a successful and
                    sustainable company that can make a lasting impact in the
                    transportation industry. We believe that by building a
                    strong foundation and staying focused on our customers and
                    our mission, we can achieve long-term success.
                    <br /> <br />
                    4. Continuously learning and improving: We are motivated by
                    the opportunity to continuously learn and improve as a
                    company. We believe that by staying curious and open to new
                    ideas, we can continue to grow and evolve as an
                    organization.
                  </li>
                </ul>
                <h2>Competition</h2>
                <ul>
                  <li>
                    <h5>
                      What are your strengths and advantages over your
                      competitors?
                    </h5>
                    1. A unique value proposition: We offer a unique value
                    proposition for both small trucking companies and shippers,
                    as we connect the two groups in a more efficient and
                    cost-effective way. By streamlining the dispatch process and
                    providing reliable transportation options, we help small
                    trucking companies increase their profitability and shippers
                    optimize their supply chain.
                    <br /> <br />
                    2. A strong team: We have a strong team of experienced
                    professionals with a deep understanding of the
                    transportation industry and a proven track record of
                    delivering value to our customers. This expertise allows us
                    to offer a high level of service and support to our
                    customers.
                    <br /> <br />
                    3. A scalable and adaptable platform: Our platform is
                    scalable and adaptable, allowing us to easily expand and
                    meet the needs of our customers as we grow. We also
                    continuously update and improve our platform based on
                    customer feedback, ensuring that it meets the changing needs
                    of the market.
                    <br /> <br />
                    4. Strong partnerships: We have strong partnerships with a
                    range of companies and organizations in the transportation
                    industry, which helps us provide additional value to our
                    customers and expand our reach.
                    <br /> <br />
                    5. A commitment to sustainability: We are committed to
                    sustainability and are constantly looking for ways to reduce
                    our environmental impact and help our customers do the same.
                    This commitment sets us apart from many of our competitors
                    and aligns with the values of many of our customers.
                  </li>
                  <li>
                    <h5>What are our weaknesses or disadvantages?</h5>
                    1. Limited geographical reach: We currently operate in South
                    Africa, which means that we do not have a global presence.
                    This could be a disadvantage for companies that operate in
                    other regions and are looking for a transportation solution
                    that covers a wider area.
                    <br /> <br />
                    2. Dependence on technology: Our platform relies on
                    technology to facilitate the connection between small
                    trucking companies and shippers and streamline the dispatch
                    process. If there are technical issues or disruptions, this
                    could impact our ability to serve our customers effectively.
                    <br /> <br />
                    3. Competition: The transportation industry is highly
                    competitive, and we face competition from other companies
                    that offer similar services. In order to stay competitive,
                    we need to continuously improve and evolve our platform and
                    services to meet the changing needs of the market.
                    <br /> <br />
                    4. Limited resources: As a smaller company, we may have
                    limited resources compared to some of our larger
                    competitors. This could impact our ability to invest in new
                    technology or expand our operations as quickly as some of
                    our competitors.
                    <br /> <br />
                    5. Regulation: The transportation industry is heavily
                    regulated, and we may face challenges in navigating these
                    regulations or complying with new regulations as they are
                    introduced. This could impact our ability to operate
                    smoothly and effectively in some cases.
                  </li>
                  <li>
                    <h5>What barriers to entry or scale are there for us?</h5>
                    Regulation: The transportation industry is heavily
                    regulated, and navigating these regulations and complying
                    with new regulations can be challenging. This can be a
                    barrier to entry or scale for companies that are new to the
                    industry or looking to expand into new markets.
                    <br /> <br />
                    Competition: The transportation industry is highly
                    competitive, and we face competition from other companies
                    that offer similar services. Establishing a strong brand and
                    building a customer base can be difficult in a crowded
                    market, and this can be a barrier to entry or scale for new
                    companies.
                    <br /> <br />
                    Capital requirements: The transportation industry can be
                    capital-intensive, and companies may need to invest in
                    infrastructure, technology, and other resources in order to
                    grow and scale their operations. This can be a barrier to
                    entry or scale for companies that do not have access to
                    sufficient capital.
                    <br /> <br />
                    Customer acquisition: Acquiring new customers and building a
                    strong customer base can be challenging, especially in a
                    crowded market. This can be a barrier to entry or scale for
                    new companies, as it can take time and resources to build a
                    customer base and generate revenue.
                    <br /> <br />
                    Technology adoption: Some customers may be resistant to
                    using new technologies, which can be a barrier to adoption
                    and scale for companies that rely on technology to
                    facilitate their services.
                  </li>
                  <li>
                    <h5>Where is the competition letting down customers?</h5>
                    It is not appropriate for QikTruck to comment on the
                    specific ways in which our competitors may be "letting down"
                    their customers. However, it is important for all companies
                    in the transportation industry to focus on meeting the needs
                    and expectations of their customers in order to drive
                    success and growth. This can involve providing reliable and
                    cost-effective transportation services, maintaining high
                    levels of customer service and support, and continuously
                    improving and evolving to meet the changing needs of the
                    market. By focusing on customer satisfaction and value,
                    companies in the transportation industry can build strong,
                    long-lasting relationships with their customers and drive
                    success for their business.
                  </li>
                </ul>
                <h2>Financials:</h2>
                <ul>
                  <li>
                    <h5>How are we marketing our product or services?</h5>
                    1. Digital marketing: We use a range of digital marketing
                    strategies to reach potential customers and partners,
                    including social media marketing, content marketing, and
                    email marketing.
                    <br /> <br />
                    2. Search engine optimization (SEO): We optimize our website
                    and content to improve our search engine rankings and make
                    it easier for potential customers to find us online.
                    <br /> <br />
                    3. Networking: We attend industry events and conferences and
                    engage in networking activities in order to build
                    relationships and connect with potential customers and
                    partners.
                    <br /> <br />
                    4. Referrals: We encourage our existing customers to refer
                    us to their friends and colleagues, which can be a powerful
                    marketing tool for our business.
                    <br /> <br />
                    5. Public relations: We engage in public relations
                    activities, such as press releases and media interviews, in
                    order to increase awareness of our brand and reach potential
                    customers and partners.
                  </li>
                </ul>
                <h2>Mission Statement:</h2>
                <ul>
                  <li>
                    Our mission at QikTruck is to make it easy for people to
                    move anything, anytime, with the convenience of our online
                    solutions.
                  </li>
                  <li>
                    Our team of experienced and professional drivers is equipped
                    with the expertise and experience to handle any situation
                    with speed and efficiency.
                  </li>
                  <li>
                    We offer a range of moving options to fit any budget,
                    including on-demand deliveries, truck hire, and a fleet of
                    owner drivers and rental vehicles.
                  </li>
                  <li>
                    We believe that our unique approach to on-demand deliveries
                    and truck hire empowers people to move goods in a way that
                    is convenient, affordable, and efficient.
                  </li>
                  <li>
                    Trust us to provide you with the high-quality service you
                    need to get your goods where they need to go.
                  </li>
                </ul>
                <h2>Values:</h2>
                <ul>
                  <li>
                    <strong>Customer Satisfaction:</strong> Our top priority is
                    ensuring customer satisfaction through well insured services
                    and timely delivery of goods.
                  </li>
                  <li>
                    <strong>Transparency:</strong> We make sure to clearly post
                    all offerings and prices before purchase.
                  </li>
                  <li>
                    <strong>Value:</strong> We offer competitive rates and a
                    variety of moving options to fit every budget.
                  </li>
                  <li>
                    <strong>Expertise:</strong> Our drivers are highly trained
                    and experienced, able to handle any situation with speed and
                    efficiency.
                  </li>
                </ul>

                <h2>Who We Are:</h2>
                <ul>
                  <li>
                    A team of experienced and professional Computer Scientists,
                    Software Engineers, Markerters, Accountants and Drivers
                  </li>
                  <li>
                    Dedicated to providing on-demand services for short or long
                    distance moves
                  </li>
                  <li>
                    Committed to providing high-quality service at a reasonable
                    price
                  </li>
                  <li>
                    Equipped with the expertise and experience to handle any
                    situation with speed and efficiency.
                  </li>
                </ul>
                <h2>What We Offer:</h2>
                <ul>
                  <li>On-demand movement of goods from point A to point B.</li>
                  <li>Truck and driver hire</li>
                  <li>A fleet of owner drivers and rental vehicles</li>
                  <li>Convenient online solutions</li>
                  <li>Route optimisation</li>
                  <li>Supplier database analytics</li>
                  <li>
                    Clear pricing and a range of options to fit any budget
                  </li>
                </ul>
                <h2>Why Choose Us:</h2>
                <ul>
                  <li>Customer satisfaction is our top priority</li>
                  <li>We are transparent about our prices and services</li>
                  <li>
                    We offer competitive rates and a variety of moving options
                  </li>
                  <li>Our drivers are highly trained and experienced</li>
                  <li>
                    We are dedicated to providing high-quality service at a
                    reasonable price.
                  </li>
                </ul>
                <p>
                  QikTruck is a digital platform that connects people in need of
                  transportation services with local professional drivers who
                  have vehicles with load capacity. Our platform allows
                  communities to control their expenses and manage their
                  transportation needs by providing a fast and readily available
                  method to move goods of any size and form from point A to
                  point B. <br />
                  <br />
                  We have created user-friendly software for our customers,
                  driver and partners, making it easy for people to find and
                  connect with local professional drivers in their community.
                  All vehicles on our platform are carefully vetted and
                  inspected to ensure they meet our high standards for safety
                  and reliability. Our drivers are trained to provide top-notch
                  service, so you can trust that your goods will be transported
                  safely and efficiently. <br />
                  <br />
                  At QikTruck, we take safety and insurance very seriously. All
                  of our drivers are required to have appropriate insurance
                  coverage, and we provide additional insurance coverage for
                  goods in transit. We also have a robust safety program in
                  place, with regular training and assessments to ensure that
                  our drivers are always operating at the highest level of
                  safety. In the unlikely event that an accident occurs, our
                  dedicated support team is available 24/7 to assist with any
                  issues and help resolve any problems. We are committed to
                  providing the best possible service to our customers and the
                  communities we serve, and we take every measure to ensure that
                  our platform is safe and reliable for everyone involved.
                </p>
                <br />
                <br />
                <p>
                  QikTruck was created by a group of Computer Scientists and
                  Logistics Experts led by Manu Matsiyana, located in Gauteng
                  South Africa. They saw a need for a more efficient and
                  cost-effective way for people to connect with local
                  professional drivers for their transportation needs and
                  created the QikTruck platform to address this need. Using
                  their knowledge of computer science and their passion for
                  mechanics, the team developed the QikTruck platform and
                  launched the company in Randburg in January 2022. QikTruck has
                  since attracted over 1300 partner drivers with readily
                  available load capacity in South Africa. <br />
                  <br />
                  Fleet load capacity:{" "}
                  <strong>4000 tonnes available daily.</strong> <br />
                  Fleet estimated value: <strong>R180 Million.</strong> <br />
                  Active drivers: <strong>1326.</strong>
                  <br />
                  Monthly quotations: <strong>6000.</strong>
                  <br />
                  Quotations generated: <strong>R70 Million.</strong>
                  <br />
                  <br />
                  from January 2022 to December 2022.
                  <br />
                  <br />
                  This has attracted interest from Business Development,
                  Marketing, and Logistics experts who have joined and teamed up
                  to work on and improve the offerings from QikTruck. With over
                  1000 applications every month for available positions.
                  <br /> Our platform connects people in need of transportation
                  services with local professional drivers who have vehicles
                  with load capacity. This allows communities to control their
                  expenses and manage their transportation needs by providing a
                  fast and readily available method to move goods of any size
                  and form from point A to point B. We have created
                  user-friendly software for our customers and driver app,
                  making it easy for people to find and connect with local
                  professional drivers in their community. All vehicles on our
                  platform are carefully vetted and inspected to ensure they
                  meet our high standards for safety and reliability. Our
                  drivers are trained to provide top-notch service, so you can
                  trust that your goods will be transported safely and
                  efficiently. <br /> <br /> Attracting interest from large
                  corporations such as Imperial Logistics. With QikTruck, you
                  can trust that your transportation needs will be handled by
                  reliable and capable vehicles and drivers using safe and
                  reliable vehicles. We are dedicated to providing the best
                  possible service to our customers and the communities we
                  serve. In addition to our platform and software, we also offer
                  a range of other services to support our customers and
                  drivers. For example, we provide training and support to
                  drivers to help them improve their skills and knowledge,
                  ensuring that they are always ready to provide the best
                  possible service. We also offer a range of tools and resources
                  to help our customers plan and manage their transportation
                  needs, including a comprehensive online dashboard that
                  provides real-time tracking and updates. At QikTruck, we are
                  committed to being a leader in the transportation industry. We
                  are constantly innovating and improving our platform and
                  services, and we are dedicated to providing the best possible
                  experience for our customers and drivers. Whether you are a
                  business owner in need of transportation services or a local
                  professional driver looking for work, QikTruck is here to help
                  you succeed.
                </p>
                <p>
                  Please contact: <b> support@qiktruck.co.za </b>for more
                  information.
                </p>
              </Col>
            </Row>
          </Container>
        </section>
      </React.Fragment>
    );
  }
}

export default Section;
